import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.newDesignDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newDesignDialogVisible) = $event)),
      width: "30%",
      "align-center": ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('newDesignPrompt.tittle')), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('newDesignPrompt.messagePart1')), 1),
          _cache[1] || (_cache[1] = _createElementVNode("b", { class: "red" }, "LoopWord", -1)),
          _createTextVNode(_toDisplayString(_ctx.$t('newDesignPrompt.messagePart2')), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}